import * as React from 'react';
import {
    styled,
    Table,
    TableBody,
    TableCell,
    tableCellClasses,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from '@mui/material';
import { CheckCircleOutline } from '@mui/icons-material';
import { translations } from '../../lib/consts';
import './success.css';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
}));

type GenericObject = { [key: string]: any };

type Props = {
    claims: GenericObject[];
};

const SucessScreen = ({ claims }: Props) => {
    function createData(requestNumber: string, requestType: string, requestDescription: string) {
        return { requestNumber, requestType, requestDescription };
    }

    const rows: GenericObject[] = [];

    claims?.map((claim) => {
        rows.push(createData(`${claim.sifraStete}`, `${claim.vrsta}`, `${claim.opis}`));
    });

    return (
        <>
            <CheckCircleOutline className="checkIcon" fontSize="large" />

            <div className="success-wrapper">
                <Typography variant="body1">
                    {claims.length > 1
                        ? translations.success.SUCCESS_MULTIPLE_1
                        : translations.success.SUCCESS_SINGLE_1}
                </Typography>
                <Typography marginBottom={2} variant="body1">
                    {claims.length > 1
                        ? translations.success.SUCCESS_MULTIPLE_2
                        : translations.success.SUCCESS_SINGLE_2}
                </Typography>
            </div>

            <TableContainer>
                <Table sx={{ minWidth: 600 }} aria-label="customized table">
                    <TableHead>
                        <TableRow>
                            <StyledTableCell align="left">{translations.success.REQUEST_NUMBER}</StyledTableCell>
                            <StyledTableCell>{translations.success.TYPE}</StyledTableCell>
                            <StyledTableCell align="left">{translations.success.DESCRIPTION}</StyledTableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {rows.map((row: any) => (
                            <StyledTableRow key={row.requestNumber}>
                                <StyledTableCell component="th" scope="row" width={'20%'}>
                                    {row.requestNumber}
                                </StyledTableCell>
                                <StyledTableCell align="left" width={'45%'}>
                                    {row.requestType}
                                </StyledTableCell>
                                <StyledTableCell align="left" width={'35%'}>
                                    {row.requestDescription}
                                </StyledTableCell>
                            </StyledTableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    );
};

export default SucessScreen;
